import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BrickSnake2000} from "../../BrickSnake2000";
import {gsap} from "gsap";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {BrickSnake2000ScatterSymbol} from "../../reels/symbols/ScatterSymbol";
import {BrickSnake2000Symbol, SymbolArgs} from "../../reels/symbols/BrickSnake2000Symbol";
import {BrickSnake2000WildSymbol} from "../../reels/symbols/WildSymbol";

export class FreeSpinsIntro implements SimplePresentation {

    name:string = "FreesSpinIntro";

    constructor() {

    }

    public shouldRun():boolean {
        return !BrickSnake2000.model.data.isRestoreState &&
               !BrickSnake2000.model.data.brokeTheBank &&
               BrickSnake2000.model.data.mode == GameMode.NORMAL &&
               (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN ||
                BrickSnake2000.model.data.nextMode == GameMode.FREESPIN_SUPER);
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        BrickSnake2000.autoPlayPlugin.turnOffAutoplayOnBonus();
        if (BrickSnake2000.autoPlayPlugin.isAutoplayRound && BrickSnake2000.model.data.wasFeatureBuy) {
            tl.add(() => {
                controller.setSkipCallback(() => {
                    tl.seek("SKIP_INTRO", false)
                });
            });
        }

        const spiral = [
            {x: 0, y: 0}, {x: 1, y: 0}, {x: 2, y: 0}, {x: 3, y: 0}, {x: 4, y: 0},
            {x: 4, y: 1}, {x: 4, y: 2}, {x: 4, y: 3}, {x: 4, y: 4},
            {x: 3, y: 4}, {x: 2, y: 4}, {x: 1, y: 4}, {x: 0, y: 4},
            {x: 0, y: 3}, {x: 0, y: 2}, {x: 0, y: 1},
            {x: 1, y: 1}, {x: 2, y: 1}, {x: 3, y: 1},
            {x: 3, y: 2}, {x: 3, y: 3},
            {x: 2, y: 3}, {x: 1, y: 3},
            {x: 1, y: 2},
            {x: 2, y: 2},
        ];
        const symbols = BrickSnake2000.baseGameReelView.getAllSymbolsActually();
        const stickyPositions = BrickSnake2000.model.stickyFreespinPosition();


        tl.add(() => {
            BrickSnake2000.soundPlayer.fadeOutMusic();
            BrickSnake2000.baseGameReelView.disableXBet();
            BrickSnake2000.soundPlayer.playSound("fsSfsActivation");
            BrickSnake2000.freespinsReelView.resetReels();
        });
        tl.add(BrickSnake2000.baseGameReelView
                             .getAllSymbols().filter((sym) => sym.symbolName == "S")
                             .map((sym) => {
                                 const index = stickyPositions.findIndex((pos) => pos.reelPosition == sym.reelPosition &&
                                                                                  pos.reelID == sym.reelID)
                                 return (<BrickSnake2000ScatterSymbol>sym).getActivateAnimation(index);
                             }));
        tl.add(stickyPositions.map((pos, index) => {
            const snakeSkin = index == 0 ? "_A" : "_B";
            const symbolArgs:SymbolArgs = {
                symbolName: "W",
                isSpinning: false,
                isStopping: false,
                reelsView: BrickSnake2000.baseGameReelView,
                reelPosition: pos.reelPosition,
                reelID: pos.reelID,
                symbolSize: 1,
                suffix: `_Head${snakeSkin}`,
            };
            return () => {
                const factory = BrickSnake2000.symbolFactory;
                const baseGameSym = <BrickSnake2000WildSymbol>factory.createSymbol(symbolArgs)
                baseGameSym.setSnakeSkin(snakeSkin)
                baseGameSym.setBodyPart("_Head");
                BrickSnake2000.baseGameReelView.replaceSymbolAt(pos.reelID, pos.reelPosition, baseGameSym) ;

                const fsReelView = BrickSnake2000.freespinsReelView.getReelModel(pos.reelID, pos.reelPosition);

                fsReelView.markAsSticky();
                const fsSymbol = <BrickSnake2000WildSymbol>factory.createSymbol(Object.assign(symbolArgs,
                                                                                              {reelsView: fsReelView}));
                fsSymbol.setSnakeSkin(snakeSkin);
                fsSymbol.setBodyPart("_Head");
                BrickSnake2000.freespinsReelView.replaceSymbolAt(pos.reelID, pos.reelPosition, fsSymbol);
            }
        }))

        tl.add(() => {}, '>0.3');
        tl.add(symbols.filter((sym) => sym.reelPosition == -1 || sym.reelPosition == 5)
                      .map((sym) => {return () => {sym.alpha = 0}}));

        spiral.filter((pos) => !stickyPositions.some((pos2) => pos.x == pos2.reelID && pos.y == pos2.reelPosition))
              .forEach((pos) => {
            const sym = symbols.find((sym) => sym.reelPosition == pos.y && sym.reelID == pos.x)!;
            tl.add(gsap.to(sym, {alpha: 0, duration: 0.025}));
            tl.add(() => BrickSnake2000.soundPlayer.playSound("snekSpinIntro1"), '<');
        });

        if (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN) {
            tl.add(BrickSnake2000.transitionScreen.showIntro(), '<0.2');
            tl.add(() => {BrickSnake2000.soundPlayer.playLoopingSound("fsIntroLoop")}, '<');
        } else {
            tl.add(BrickSnake2000.transitionScreen.showIntroSuper(), '<0.2');
            tl.add(() => {BrickSnake2000.soundPlayer.playLoopingSound("sfsIntroLoop")}, '<');
        }
        tl.add(() => BrickSnake2000.soundPlayer.playSound("snekSpinIntro2"), '<');
        tl.add(() => {BrickSnake2000.soundPlayer.playSound("introOneShot")}, '<');
        tl.add(<any>BrickSnake2000.keypadPlugin.hide(0.1), '<');
        if (BrickSnake2000.autoPlayPlugin.isAutoplayRound && BrickSnake2000.model.data.wasFeatureBuy) {
            tl.add(() => this.onButtonClick(controller), '>1.2');
            tl.addLabel("SKIP_INTRO");
        } else {
            tl.add(BrickSnake2000.transitionScreen.enableButton(() => this.onButtonClick(controller)), '<0.1');
        }
        tl.add(() => controller.setSkipCallback());
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            BrickSnake2000.keypadPlugin.setZeroBetSpinCounter(0);
            BrickSnake2000.keypadPlugin.show(0.1);
            BrickSnake2000.baseGameReelView.disable();
            BrickSnake2000.freespinsReelView.resetKillerCount();
            BrickSnake2000.freespinsReelView.resetWallet();
            BrickSnake2000.freespinsReelView.clearDeadSneks();
            BrickSnake2000.freespinsReelView.resetCollectorCounter();
            BrickSnake2000.freespinsReelView.resetFsMultiplier();
            BrickSnake2000.freespinsReelView.enable();
        });
        if (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN) {
            tl.add(BrickSnake2000.backgroundElements.setToFreespins());
            tl.add(BrickSnake2000.transitionScreen.hideIntro(), '<');
            tl.add(() => {
                BrickSnake2000.soundPlayer.stopSound("fsIntroLoop");
                BrickSnake2000.soundPlayer.switchMusic(GameMode.FREESPIN);
            }, '<')
        } else {
            tl.add(BrickSnake2000.backgroundElements.setToSuperFreespins());
            tl.add(BrickSnake2000.transitionScreen.hideIntroSuper(), '<');
            tl.add(() => {
                BrickSnake2000.soundPlayer.stopSound("sfsIntroLoop");
                BrickSnake2000.freespinsReelView.enableCollectorDisplay();
                BrickSnake2000.soundPlayer.switchMusic(GameMode.FREESPIN_SUPER)
            }, '<')
        }
        tl.add(() => BrickSnake2000.soundPlayer.fadeInMusic(), '<');
        tl.add(() => controller.finish());
        tl.add(() => controller.setSkipCallback());

    }
}

export class FreeSpinsRestoreIntro extends FreeSpinsIntro {

    name: string = "FreesSpinRestoreIntro";

    constructor() {
        super();
    }

    public shouldRun():boolean {
        return BrickSnake2000.model.data.isRestoreState &&
               !BrickSnake2000.model.data.brokeTheBank &&
               BrickSnake2000.model.data.mode == GameMode.NORMAL &&
               (BrickSnake2000.model.data.nextMode == GameMode.FREESPIN ||
                BrickSnake2000.model.data.nextMode == GameMode.FREESPIN_SUPER);
    }
}

